import { cva } from 'class-variance-authority'
import type { HTMLAttributes } from 'react'
import { cn } from '../../lib/cn'
import { Icon } from '../icon/icon'

/** Pill Deadline (410:44318): a white badge with the calendar icon and an accent date, at most 350px wide. */
export const pillDeadlineVariants = cva(
	'inline-flex max-w-87.5 items-center justify-center gap-1.5 rounded-atlas-badge bg-atlas-light px-3.5 py-2 font-atlas-sans text-atlas-body-semibold text-atlas-accent',
)

export interface PillDeadlineProps extends Omit<HTMLAttributes<HTMLSpanElement>, 'children'> {
	/** The formatted deadline, e.g. "23 Oct 2026 (04:00 PM)". Formatting is the caller's. */
	label: string
}

/** A work order's deadline badge; a long label truncates with an ellipsis. */
export function PillDeadline({ label, className, ...props }: PillDeadlineProps) {
	return (
		<span {...props} className={cn(pillDeadlineVariants(), className)}>
			<Icon name="calendar-03" />
			<span className="truncate">{label}</span>
		</span>
	)
}
